import React, { CSSProperties, useEffect, useRef, useState } from "react";

import { Label } from "semantic-ui-react";

// @ts-ignore
import { ColorResult, SketchPicker } from "react-color";

type ColorPickerProps = {
  id?: any;
  style?: CSSProperties;
  value?: string;
  onChange?: (color: string) => void;
};

const PASTEL_COLORS = [
  "#FFB3BA",
  "#FFDFBA",
  "#FFD1DC",
  "#FFFFBA",
  "#FFE135",
  "#FFCC99",
  "#BAFFC9",
  "#BAE1FF",
  "#C7CEEA",
  "#B5E7FF",
  "#87CEEB",
  "#98D8E8",
  "#D4B5FF",
  "#E6E6FA",
  "#F0E6FF",
  "#C8C8C8",
];

const ColorPicker = (props: ColorPickerProps) => {
  const [color, setColor] = useState<string>("");
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setColor(props.value || "");
  }, [props.value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  const handleColorChange = (colorResult: ColorResult): void => {
    setColor(colorResult.hex);
    props.onChange?.(colorResult.hex);
  };

  return (
    <div
      id={props.id ?? "ColorPicker-Div"}
      ref={containerRef}
      style={{
        backgroundColor: "white",
        border: "1px solid rgba(34, 36, 38, 0.15)",
        borderRadius: "0.285714rem",
        marginTop: "-5px",
        padding: "5px",
        position: "relative",
      }}
    >
      <Label
        style={{
          backgroundColor: color,
          border: "1px solid rgba(34,36,38,.15)",
          cursor: "pointer",
          padding: "3px",
          width: "2.5rem",
          ...props.style,
        }}
        onClick={() => {
          setShowPicker(!showPicker);
        }}
      >
        {"\u00A0"}
      </Label>

      {showPicker && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "35px",
            zIndex: 1000,
          }}
        >
          <SketchPicker color={color} presetColors={PASTEL_COLORS} onChange={handleColorChange} />
        </div>
      )}
    </div>
  );
};

ColorPicker.displayName = "ColorPicker";

export default React.memo(ColorPicker);
